import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import dataService from 'api/dataService';
import { setOrder } from 'filters/actions';
import { filterData } from 'filters/selectors';
import { getData, dataReceived } from 'datahub/actions';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { CategoriesText } from 'components/layouts';
import { images, strings } from 'config';
import { numberTranslate } from 'utils';

class DataTable extends Component {
  state = {};

  goToDetail = id => {
    this.props.history.push('/detail/' + id);
  };

  onSortHeader = val => {
    const { filters, handleFilters } = this.props;

    let sort = filters.headerSort.sort;
    if (filters.headerSort.name === val) {
      sort = sort === 'asc' ? 'desc' : 'asc';
    } else {
      sort = 'asc';
    }
    const filteredResult = {
      ...filters,
      ...{
        headerSort: {
          name: val,
          sort: sort
        }
      }
    };
    handleFilters(filteredResult);
  };

  render() {
    const { data } = this.props;

    const selectedLang = strings.getLanguage();


    const headers = [
      {
        label: strings.filters.documentTitle,
        value: 'document_title'
      },
      {
        label: strings.filters.documentType,
        value: 'document_type'
      },
      {
        label: strings.filters.documentSource,
        value: 'document_source'
      }
    ];

    return (
      <Table lang={strings.getLanguage()} 
            title={strings.filters.documentTitle}
            type={strings.filters.documentType}
            source={strings.filters.documentType}
            category={strings.filters.categories}
            subcategory={strings.filters.subCategories}
            >
        <thead>
          <tr>
            {headers.map((val, index) => (
              <td key={index} onClick={() => this.onSortHeader(val.value)}>
                {val.label} <img src={images.icons.toggleArrow} alt="" />
              </td>
            ))}
            <td>{strings.filters.categories} ({strings.filters.subCategories})</td>
          </tr>
        </thead>
        <tbody>
          {data.map((val, index) => (
            <tr key={index} onClick={() => this.goToDetail(val.id)}>
              <td>
                {val.document_title} {val.published_year && <Fragment>({numberTranslate(val.published_year)})</Fragment>}
              </td>
              <td>{ selectedLang === 'en' ? val.document_type.en : val.document_type.ne }</td>

              <td>
                {selectedLang === 'en' ? <Fragment>{val.document_source.en ? val.document_source.en : <span className="no-data">-</span> }</Fragment> 
                : <Fragment>{val.document_source.ne ? val.document_source.ne : <span className="no-data">-</span> }</Fragment> }  
                </td>
              <td>
                <CategoriesText categories={val.categories} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleFilters: filters => {
      dispatch(setOrder(filters.headerSort));
      const queryParams = filterData(filters);
      dispatch(getData());
      dataService.getDataList(queryParams).then(response => {
        dispatch(dataReceived(response));
      });
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataTable));

const Table = styled.table`
  width: 100%;
  thead {
    tr {
      border-top: 1px solid rgba(151, 151, 151, 0.26);
      border-bottom: 1px solid rgba(151, 151, 151, 0.26);

      td {
        color: rgba(151, 151, 151, 0.52);
        font-size: ${props => props.lang === 'en' ? '12px' : '14px'};
        font-weight: 600;
        padding: 15px 20px;
        white-space: nowrap;

        &:first-child {
          padding-left: 40px;
        }
        &:last-child {
          padding-right: 40px;
        }

        &:not(:last-child) {
          cursor: pointer;
        }

        img {
          margin-left: 5px;
        }
      }
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid rgba(151, 151, 151, 0.26);
      cursor: pointer;

      td {
        font-size: ${props => props.lang === 'en' ? '14px' : '16px'};
        color: ${props => props.theme.primary.raatri};
        padding: 24px 20px;
        line-height: 1.5;

        &:first-child {
          padding-left: 40px;
          cursor: pointer;
        }
        &:last-child {
          padding-right: 40px;
        }

        .no-data {
          opacity: 0.6;
        }
      }

      &:hover {
        background-color: rgba(154, 237, 231, 0.09);
        td {
          &:first-child {
            color: ${props => props.theme.teals.tilicho};
          }
        }
      }
    }
  }

  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    /* Force table to not be like tables anymore */
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;

      td {
        color: ${props => props.title};
        /* Behave  like a "row" */
        position: relative !important;
        border-bottom: 1px solid rgba(#fff, 0.05);
        padding: 10px 20px 10px 192px !important;
        &:before {
          /* Now like a table header */
          position: absolute;
          top: 50%;
          left: 24px;
          width: 45%;
          padding-right: 10px;
          text-transform: uppercase;
          transform: translateY(-50%);
          color: rgba(151, 151, 151, 0.52);
          font-size: ${props => props.lang === 'en' ? '12px' : '14px'};
          font-weight: 600;
        }
        &:nth-of-type(1):before {
          content: ${props => "'" + props.title + "'"};
        }
        &:nth-of-type(2):before {
          content: ${props => "'" + props.type + "'"};
        }
        &:nth-of-type(3):before {
          content: ${props => "'" + props.source + "'"};;
        }
        &:nth-of-type(4):before {
          content: ${props => "'" + props.category + " ("+ props.subcategory +") " + "'"};;
        }
      }

    }
    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

  
  }
  @media screen and (max-width: 600px){

    tbody{
      tr{
        td{
          padding: 6px 20px !important;
          &:before{
            position: relative;
            display: block;
            width: 100%;
            transform: initial;
            left: 0;
          }
          &:first-child{
            padding-left: 20px;
          }
          
        }
      }
    }
    
  }
`;





// WEBPACK FOOTER //
// ./src/components/layouts/dataTable/dataTable.js